var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStocksThumb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#539384"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0449 25.813C21.4405 25.813 25.8145 21.4391 25.8145 16.0435C25.8145 10.6479 21.4405 6.27393 16.0449 6.27393C10.6494 6.27393 6.27539 10.6479 6.27539 16.0435C6.27539 21.4391 10.6494 25.813 16.0449 25.813ZM16.7422 11.8565C16.1641 11.8565 15.6955 12.3252 15.6955 12.9033C15.6955 13.4814 16.1641 13.95 16.7422 13.95H18.6224L16.239 16.6739L14.1123 14.8792C13.6714 14.5071 13.0126 14.5619 12.6393 15.0017L9.66385 18.5062C9.28971 18.9469 9.34365 19.6075 9.78434 19.9816C10.225 20.3558 10.8856 20.3019 11.2597 19.8612L13.5597 17.1521L15.6746 18.9369C16.1108 19.305 16.7616 19.2558 17.1375 18.8262L19.8824 15.6891V17.0902C19.8824 17.6683 20.3511 18.137 20.9292 18.137C21.5073 18.137 21.9759 17.6683 21.9759 17.0902V12.9033C21.9759 12.3252 21.5073 11.8565 20.9292 11.8565H16.7422Z",
    fill: "white"
  })));
}

export default SvgStocksThumb;